@if (title) {
    <div class="detail-list-title">{{title}}</div>
}

@if ((entries ?? []).length > 0) {
    <div class="detail-list">
        @for (detail of entries ?? []; track detail.label) {
            <div class="detail-row">
                <span class="detail-label">{{detail.label}}</span>
                <span class="detail-value">{{formatDetailValue(detail.value)}}</span>
            </div>
        }
    </div>
}
@else if (emptyText) {
    <div class="detail-list-empty">{{emptyText}}</div>
}

